<template lang="pug">
v-container(fluid)
  .d-flex.align-center.mb-4
    PageHeader.flex-grow-1(v-if="commercialProjection" :title="commercialProjection.name" backTo="/proyeccion-comercial")
    v-btn.ml-3(color="primary" depressed :to="`/proyeccion-comercial/${$route.params.id}/reporte`")
      v-icon(left) mdi-file-pdf-box
      | Exportar reporte
  //- Filtros de búsqueda
  v-card.mb-4
    v-card-text
      v-form(@submit.prevent="filter")
        v-row
          v-col
            v-row
              //- Campos de filtro
              v-col(cols="12" md="3")
                v-autocomplete(
                  v-model="filters.customer"
                  :items="customers"
                  :search-input.sync="searchCustomer"
                  label="Cliente"
                  return-object
                  item-text="name"
                  outlined
                  hide-details
                  multiple
                  chips
                  no-filter)
              v-col(cols="12" md="3")
                v-autocomplete(
                  v-model="filters.lineOfBusiness"
                  :items="lineOfBusiness"
                  :search-input.sync="searchLineOfBusiness"
                  label="Línea de negocio"
                  return-object
                  item-text="name"
                  outlined
                  hide-details
                  multiple
                  chips
                  no-filter)
              v-col(cols="12" md="3")
                v-autocomplete(
                  v-model="filters.product"
                  :items="products"
                  label="Producto"
                  :search-input.sync="searchProduct"
                  return-object
                  item-text="name"
                  outlined
                  multiple
                  chips
                  hide-details)
              v-col(v-if="!isSimpleMode" cols="12" md="3")
                v-autocomplete(
                  v-model="filters.attribute"
                  :items="attributes"
                  label="Atributo"
                  :search-input.sync="searchAttribute"
                  return-object
                  :item-text="attributeName"
                  outlined
                  multiple
                  no-filter
                  chips
                  hide-details)
          v-col(cols="12" md="auto")
            v-row
              v-col(cols="12" md="auto")
                //- Botón de búsqueda
                v-btn(color="primary" type="submit" block height="54") Filtrar

  //- Gráfico de proyección comercial
  v-row
    v-col(cols="12" md="12")
      v-card(:id="WIZARD_ELEMENTS_ID.ANALIYSIS_COMMERCIAL_PROJECTION")
        v-toolbar(color="primary" dark flat)
          v-tabs(v-model="currentTab" grow)
            v-tab(v-for="tab in tabs" :key="tab" ) {{ tab }}
        v-tabs-items.mt-3.case-tabs(v-model="currentTab")

          v-tab-item(key="POTENCIAL COMERCIAL")
            div(:id="WIZARD_ELEMENTS_ID.SECTION_MARKET_SIZE")
              v-row
                v-col(cols="12" md="3" style="background-color: #f5f5f5")
                  .ml-3.mt-3
                    CommercialProjectionByCustomerChart.mb-4(:filters="currentFilters")
                    TableProductTop(:filters="currentFilters")
                v-col(cols="12" md="9")
                  MarketSize(:filters="currentFilters" @updateMarketSize="marketSize = $event")
                  HeatMap(:filters="currentFilters" :marketSize="marketSize")

          v-tab-item(key="MIX OPTIMO")
            div(:id="WIZARD_ELEMENTS_ID.SECTION_OPTIMAL_MIX")
              ProductRankingComparison.mb-4(:filters="currentFilters")
              v-row.mb-1
                v-col(cols="12" md="6")
                  PriceSensitivity(:filters="currentFilters")
                v-col(cols="12" md="6")
                  CustomerConcentration(:filters="currentFilters")
              BreakEven.mb-4(:filters="currentFilters")
              CapacityUtilization.mb-4(:filters="currentFilters")
              ChartOptimalMix(:filters="currentFilters" :totalYearProfit="totalYearProfit")
              TableOptimalMix(:filters="currentFilters" @setTotalYearProfit="totalYearProfit = $event")

          v-tab-item(key="PLAN DE VENTAS")
            div(:id="WIZARD_ELEMENTS_ID.SECTION_SALE_PLAN")
              SalePlanTab(:filters="currentFilters")
</template>

<script>
import CommercialProjectionByCustomerChart from '@/components/commercial_projection/charts/CommercialProjectionByCustomerChart.vue'
import TableProductTop from '@/components/commercial_projection/charts/TableProductTop.vue'
import MarketSize from '@/components/commercial_projection/charts/MarketSize.vue'
import HeatMap from '../components/commercial_projection/charts/HeatMap.vue'
import ChartOptimalMix from '../components/commercial_projection/charts/ChartOptimalMix.vue'
import ProductRankingComparison from '@/components/commercial_projection/charts/ProductRankingComparison.vue'
import PriceSensitivity from '@/components/commercial_projection/charts/PriceSensitivity.vue'
import CustomerConcentration from '@/components/commercial_projection/charts/CustomerConcentration.vue'
import BreakEven from '@/components/commercial_projection/charts/BreakEven.vue'
import CapacityUtilization from '@/components/commercial_projection/charts/CapacityUtilization.vue'
import TableOptimalMix from '../components/commercial_projection/charts/TableOptimalMix.vue'
import SalePlanTab from '@/components/commercial_projection/SalePlanTab.vue'
import PageHeader from '@/components/common/PageHeader.vue'
import { WIZARD_ELEMENTS_ID } from '@/constants'

import { debounce } from 'debounce'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    CommercialProjectionByCustomerChart,
    MarketSize,
    TableProductTop,
    HeatMap,
    ChartOptimalMix,
    ProductRankingComparison,
    PriceSensitivity,
    CustomerConcentration,
    BreakEven,
    CapacityUtilization,
    TableOptimalMix,
    SalePlanTab,
    PageHeader,
  },
  data() {
    return {
      WIZARD_ELEMENTS_ID,
      filters: {
        customer: [],
        lineOfBusiness: [],
        product: [],
        attribute: [],
      },
      currentFilters: {},
      searchProduct: null,
      searchCustomer: null,
      searchLineOfBusiness: null,
      searchAttribute: null,
      currentTab: this.parseTab(),
      tabs: ['POTENCIAL COMERCIAL', 'MIX ÓPTIMO', 'PLAN ALCANZABLE (SOM)'],
      customers: [],
      lineOfBusiness: [],
      products: [],
      attributes: [],
      totalYearProfit: 0,
      marketSize: 0,
      commercialProjection: null,
    }
  },
  computed: {
    ...mapGetters('app_config', ['currentBusiness']),
    isSimpleMode() {
      return this.currentBusiness && this.currentBusiness.catalog_mode === 'simplificado'
    },
  },
  methods: {
    ...mapActions('product', ['listProducts', 'listLineOfBusiness', 'listAttributeOptions']),
    ...mapActions('customer', ['listCustomers']),
    ...mapActions('commercial_projection', ['getCommercialProjection']),
    filter() {
      this.currentFilters = {
        customer__in: this.filters.customer?.map(c => c.id).join(','),
        line_of_business__in: this.filters.lineOfBusiness?.map(l => l.id).join(','),
        product__in: this.filters.product?.map(p => p.id).join(','),
        attribute_option__in: this.filters.attribute?.map(a => a.id).join(','),
      }
    },
    async fetchCustomers() {
      const params = {
        search: this.searchCustomer,
        projection: this.$route.params.id,
        page_size: 25
      }
      const { data, error } = await this.listCustomers({ params })
      if (!error) {
        this.customers = [...this.filters.customer, ...data.results]
      }
    },
    async fetchComercialProjection() {
      const { data, error } = await this.getCommercialProjection(this.$route.params.id)
      if (!error) {
        this.commercialProjection = data
      }
    },
    async fetchLineOfBusiness() {
      const params = {
        search: this.searchLineOfBusiness,
        projection: this.$route.params.id,
        page_size: 25
      }
      const { data, error } = await this.listLineOfBusiness({ params })
      if (!error) {
        this.lineOfBusiness = [...this.filters.lineOfBusiness, ...data]
      }
    },
    async fetchAttributes () {
      const params = {
        search: this.searchAttribute,
        projection: this.$route.params.id,
        page_size: 25
      }
      const { data, error } = await this.listAttributeOptions({ params })
      if (!error) {
        this.attributes = [...this.filters.attribute, ...data.results]
      }
    },
    async fetchProducts() {
      const params = {
        search: this.searchProduct,
        projection: this.$route.params.id,
        page_size: 25
      }
      const { data, error } = await this.listProducts({ params })
      if (!error) {
        this.products = [...this.filters.product, ...data.results]
      }
    },
    attributeName(item) {
      if (item) {
        return `${item.attribute_name}: ${item.name}`;
      }
      return ''
    },
    parseTab() {

      if (this.$route.query.tab) {
        return parseInt(this.$route.query.tab)
      }
      return 0
    }
  },
  watch: {
    // Filtros reactivos: al cambiar cualquier selección se aplica el filtro
    // (con debounce), sin obligar a apretar "Filtrar".
    filters: {
      handler() {
        this.debouncedFilter()
      },
      deep: true,
    },
    searchProduct() {
      this.fetchProducts()
    },
    searchCustomer() {
      this.fetchCustomers()
    },
    searchLineOfBusiness() {
      this.fetchLineOfBusiness()
    },
    searchAttribute() {
      this.fetchAttributes()
    },
    $route(to, from) {
      this.currentTab = this.parseTab()
    },
    // Los gráficos (Chart.js) viven dentro de pestañas: al cambiar de pestaña el
    // contenedor recién obtiene tamaño, así que forzamos un resize para que se redibujen.
    currentTab() {
      this.$nextTick(() => {
        setTimeout(() => window.dispatchEvent(new Event('resize')), 50)
      })
    }
  },
  mounted() {
    // Al montar, los canvas pueden crearse en 0x0 (contenedor sin tamaño aún).
    // Un resize tras el primer render y tras cargar datos los dimensiona bien.
    this.$nextTick(() => window.dispatchEvent(new Event('resize')))
    setTimeout(() => window.dispatchEvent(new Event('resize')), 400)
  },
  created() {
    this.debouncedFilter = debounce(this.filter, 400)
    this.fetchCustomers = debounce(this.fetchCustomers, 500)
    this.fetchLineOfBusiness = debounce(this.fetchLineOfBusiness, 500)
    this.fetchProducts = debounce(this.fetchProducts, 500)
    this.fetchAttributes = debounce(this.fetchAttributes, 500)
    this.fetchComercialProjection()
    this.fetchCustomers()
    this.fetchLineOfBusiness()
    this.fetchProducts()
    this.fetchAttributes()
  },
}
</script>

<style>
/* Solo el contenido de la pestaña activa se muestra (evita el efecto de "dos
   tableros a la vez" que se veía al renderizarse todas las pestañas juntas). */
.case-tabs .v-window-item:not(.v-window-item--active) {
  display: none !important;
}
</style>
